// extracted by mini-css-extract-plugin
export var button = "_67-0";
export var icon = "_67-1";